/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createShow = /* GraphQL */ `mutation CreateShow(
  $input: CreateShowInput!
  $condition: ModelShowConditionInput
) {
  createShow(input: $input, condition: $condition) {
    id
    name
    version
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShowMutationVariables,
  APITypes.CreateShowMutation
>;
export const updateShow = /* GraphQL */ `mutation UpdateShow(
  $input: UpdateShowInput!
  $condition: ModelShowConditionInput
) {
  updateShow(input: $input, condition: $condition) {
    id
    name
    version
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShowMutationVariables,
  APITypes.UpdateShowMutation
>;
export const deleteShow = /* GraphQL */ `mutation DeleteShow(
  $input: DeleteShowInput!
  $condition: ModelShowConditionInput
) {
  deleteShow(input: $input, condition: $condition) {
    id
    name
    version
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteShowMutationVariables,
  APITypes.DeleteShowMutation
>;
export const createShowSetting = /* GraphQL */ `mutation CreateShowSetting(
  $input: CreateShowSettingInput!
  $condition: ModelShowSettingConditionInput
) {
  createShowSetting(input: $input, condition: $condition) {
    id
    name
    title
    description
    slug
    startDateTime
    endDateTime
    status
    owner
    showID
    version
    createdAt
    updatedAt
    ogpImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShowSettingMutationVariables,
  APITypes.CreateShowSettingMutation
>;
export const updateShowSetting = /* GraphQL */ `mutation UpdateShowSetting(
  $input: UpdateShowSettingInput!
  $condition: ModelShowSettingConditionInput
) {
  updateShowSetting(input: $input, condition: $condition) {
    id
    name
    title
    description
    slug
    startDateTime
    endDateTime
    status
    owner
    showID
    version
    createdAt
    updatedAt
    ogpImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShowSettingMutationVariables,
  APITypes.UpdateShowSettingMutation
>;
export const deleteShowSetting = /* GraphQL */ `mutation DeleteShowSetting(
  $input: DeleteShowSettingInput!
  $condition: ModelShowSettingConditionInput
) {
  deleteShowSetting(input: $input, condition: $condition) {
    id
    name
    title
    description
    slug
    startDateTime
    endDateTime
    status
    owner
    showID
    version
    createdAt
    updatedAt
    ogpImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteShowSettingMutationVariables,
  APITypes.DeleteShowSettingMutation
>;
export const createShowMain = /* GraphQL */ `mutation CreateShowMain(
  $input: CreateShowMainInput!
  $condition: ModelShowMainConditionInput
) {
  createShowMain(input: $input, condition: $condition) {
    id
    title
    mapDiscription
    logoDiscription
    discription
    section
    status
    showID
    search
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShowMainMutationVariables,
  APITypes.CreateShowMainMutation
>;
export const updateShowMain = /* GraphQL */ `mutation UpdateShowMain(
  $input: UpdateShowMainInput!
  $condition: ModelShowMainConditionInput
) {
  updateShowMain(input: $input, condition: $condition) {
    id
    title
    mapDiscription
    logoDiscription
    discription
    section
    status
    showID
    search
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShowMainMutationVariables,
  APITypes.UpdateShowMainMutation
>;
export const deleteShowMain = /* GraphQL */ `mutation DeleteShowMain(
  $input: DeleteShowMainInput!
  $condition: ModelShowMainConditionInput
) {
  deleteShowMain(input: $input, condition: $condition) {
    id
    title
    mapDiscription
    logoDiscription
    discription
    section
    status
    showID
    search
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteShowMainMutationVariables,
  APITypes.DeleteShowMainMutation
>;
export const createTeaser = /* GraphQL */ `mutation CreateTeaser(
  $input: CreateTeaserInput!
  $condition: ModelTeaserConditionInput
) {
  createTeaser(input: $input, condition: $condition) {
    id
    title
    discription
    countDown
    section
    status
    showID
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTeaserMutationVariables,
  APITypes.CreateTeaserMutation
>;
export const updateTeaser = /* GraphQL */ `mutation UpdateTeaser(
  $input: UpdateTeaserInput!
  $condition: ModelTeaserConditionInput
) {
  updateTeaser(input: $input, condition: $condition) {
    id
    title
    discription
    countDown
    section
    status
    showID
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeaserMutationVariables,
  APITypes.UpdateTeaserMutation
>;
export const deleteTeaser = /* GraphQL */ `mutation DeleteTeaser(
  $input: DeleteTeaserInput!
  $condition: ModelTeaserConditionInput
) {
  deleteTeaser(input: $input, condition: $condition) {
    id
    title
    discription
    countDown
    section
    status
    showID
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTeaserMutationVariables,
  APITypes.DeleteTeaserMutation
>;
export const createPage = /* GraphQL */ `mutation CreatePage(
  $input: CreatePageInput!
  $condition: ModelPageConditionInput
) {
  createPage(input: $input, condition: $condition) {
    id
    root
    slug
    title
    discription
    contents
    status
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePageMutationVariables,
  APITypes.CreatePageMutation
>;
export const updatePage = /* GraphQL */ `mutation UpdatePage(
  $input: UpdatePageInput!
  $condition: ModelPageConditionInput
) {
  updatePage(input: $input, condition: $condition) {
    id
    root
    slug
    title
    discription
    contents
    status
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePageMutationVariables,
  APITypes.UpdatePageMutation
>;
export const deletePage = /* GraphQL */ `mutation DeletePage(
  $input: DeletePageInput!
  $condition: ModelPageConditionInput
) {
  deletePage(input: $input, condition: $condition) {
    id
    root
    slug
    title
    discription
    contents
    status
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePageMutationVariables,
  APITypes.DeletePageMutation
>;
export const createTopPage = /* GraphQL */ `mutation CreateTopPage(
  $input: CreateTopPageInput!
  $condition: ModelTopPageConditionInput
) {
  createTopPage(input: $input, condition: $condition) {
    id
    title
    discription
    contents
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTopPageMutationVariables,
  APITypes.CreateTopPageMutation
>;
export const updateTopPage = /* GraphQL */ `mutation UpdateTopPage(
  $input: UpdateTopPageInput!
  $condition: ModelTopPageConditionInput
) {
  updateTopPage(input: $input, condition: $condition) {
    id
    title
    discription
    contents
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTopPageMutationVariables,
  APITypes.UpdateTopPageMutation
>;
export const deleteTopPage = /* GraphQL */ `mutation DeleteTopPage(
  $input: DeleteTopPageInput!
  $condition: ModelTopPageConditionInput
) {
  deleteTopPage(input: $input, condition: $condition) {
    id
    title
    discription
    contents
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTopPageMutationVariables,
  APITypes.DeleteTopPageMutation
>;
export const createShowBooth = /* GraphQL */ `mutation CreateShowBooth(
  $input: CreateShowBoothInput!
  $condition: ModelShowBoothConditionInput
) {
  createShowBooth(input: $input, condition: $condition) {
    id
    name
    title
    discription
    section
    priority
    status
    showID
    owner
    version
    createdAt
    updatedAt
    brandLogos {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShowBoothMutationVariables,
  APITypes.CreateShowBoothMutation
>;
export const updateShowBooth = /* GraphQL */ `mutation UpdateShowBooth(
  $input: UpdateShowBoothInput!
  $condition: ModelShowBoothConditionInput
) {
  updateShowBooth(input: $input, condition: $condition) {
    id
    name
    title
    discription
    section
    priority
    status
    showID
    owner
    version
    createdAt
    updatedAt
    brandLogos {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShowBoothMutationVariables,
  APITypes.UpdateShowBoothMutation
>;
export const deleteShowBooth = /* GraphQL */ `mutation DeleteShowBooth(
  $input: DeleteShowBoothInput!
  $condition: ModelShowBoothConditionInput
) {
  deleteShowBooth(input: $input, condition: $condition) {
    id
    name
    title
    discription
    section
    priority
    status
    showID
    owner
    version
    createdAt
    updatedAt
    brandLogos {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteShowBoothMutationVariables,
  APITypes.DeleteShowBoothMutation
>;
export const createShowBoothItem = /* GraphQL */ `mutation CreateShowBoothItem(
  $input: CreateShowBoothItemInput!
  $condition: ModelShowBoothItemConditionInput
) {
  createShowBoothItem(input: $input, condition: $condition) {
    id
    name
    title
    readingName
    description
    keyword
    movie
    brand
    price
    boatType
    height
    capacity
    view360
    section
    productUrl
    mapPriority
    badge
    status
    boothID
    showID
    owner
    version
    priority
    mapIndex
    boothIndex
    boothOrder
    mapOrder
    isExhibition
    createdAt
    updatedAt
    photoGallery {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    mainImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    logo {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    mapIcon {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    thumbnail {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShowBoothItemMutationVariables,
  APITypes.CreateShowBoothItemMutation
>;
export const updateShowBoothItem = /* GraphQL */ `mutation UpdateShowBoothItem(
  $input: UpdateShowBoothItemInput!
  $condition: ModelShowBoothItemConditionInput
) {
  updateShowBoothItem(input: $input, condition: $condition) {
    id
    name
    title
    readingName
    description
    keyword
    movie
    brand
    price
    boatType
    height
    capacity
    view360
    section
    productUrl
    mapPriority
    badge
    status
    boothID
    showID
    owner
    version
    priority
    mapIndex
    boothIndex
    boothOrder
    mapOrder
    isExhibition
    createdAt
    updatedAt
    photoGallery {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    mainImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    logo {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    mapIcon {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    thumbnail {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShowBoothItemMutationVariables,
  APITypes.UpdateShowBoothItemMutation
>;
export const deleteShowBoothItem = /* GraphQL */ `mutation DeleteShowBoothItem(
  $input: DeleteShowBoothItemInput!
  $condition: ModelShowBoothItemConditionInput
) {
  deleteShowBoothItem(input: $input, condition: $condition) {
    id
    name
    title
    readingName
    description
    keyword
    movie
    brand
    price
    boatType
    height
    capacity
    view360
    section
    productUrl
    mapPriority
    badge
    status
    boothID
    showID
    owner
    version
    priority
    mapIndex
    boothIndex
    boothOrder
    mapOrder
    isExhibition
    createdAt
    updatedAt
    photoGallery {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    mainImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    logo {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    mapIcon {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    thumbnail {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteShowBoothItemMutationVariables,
  APITypes.DeleteShowBoothItemMutation
>;
export const createBoothUserInfo = /* GraphQL */ `mutation CreateBoothUserInfo(
  $input: CreateBoothUserInfoInput!
  $condition: ModelBoothUserInfoConditionInput
) {
  createBoothUserInfo(input: $input, condition: $condition) {
    id
    chatUrl
    chatStatus
    contactTel
    contactTelInfo
    contactEmail
    contactAddress
    web
    facebook
    boothID
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBoothUserInfoMutationVariables,
  APITypes.CreateBoothUserInfoMutation
>;
export const updateBoothUserInfo = /* GraphQL */ `mutation UpdateBoothUserInfo(
  $input: UpdateBoothUserInfoInput!
  $condition: ModelBoothUserInfoConditionInput
) {
  updateBoothUserInfo(input: $input, condition: $condition) {
    id
    chatUrl
    chatStatus
    contactTel
    contactTelInfo
    contactEmail
    contactAddress
    web
    facebook
    boothID
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBoothUserInfoMutationVariables,
  APITypes.UpdateBoothUserInfoMutation
>;
export const deleteBoothUserInfo = /* GraphQL */ `mutation DeleteBoothUserInfo(
  $input: DeleteBoothUserInfoInput!
  $condition: ModelBoothUserInfoConditionInput
) {
  deleteBoothUserInfo(input: $input, condition: $condition) {
    id
    chatUrl
    chatStatus
    contactTel
    contactTelInfo
    contactEmail
    contactAddress
    web
    facebook
    boothID
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBoothUserInfoMutationVariables,
  APITypes.DeleteBoothUserInfoMutation
>;
export const createAlbum = /* GraphQL */ `mutation CreateAlbum(
  $input: CreateAlbumInput!
  $condition: ModelAlbumConditionInput
) {
  createAlbum(input: $input, condition: $condition) {
    id
    name
    owner
    version
    createdAt
    updatedAt
    phots {
      items {
        id
        albumID
        photID
        albumOrder
        owner
        version
        createdAt
        updatedAt
        album {
          id
          name
          owner
          version
          createdAt
          updatedAt
          phots {
            nextToken
            __typename
          }
          __typename
        }
        phot {
          id
          alternate
          storage {
            bucket
            region
            key
            __typename
          }
          url
          owner
          version
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlbumMutationVariables,
  APITypes.CreateAlbumMutation
>;
export const updateAlbum = /* GraphQL */ `mutation UpdateAlbum(
  $input: UpdateAlbumInput!
  $condition: ModelAlbumConditionInput
) {
  updateAlbum(input: $input, condition: $condition) {
    id
    name
    owner
    version
    createdAt
    updatedAt
    phots {
      items {
        id
        albumID
        photID
        albumOrder
        owner
        version
        createdAt
        updatedAt
        album {
          id
          name
          owner
          version
          createdAt
          updatedAt
          phots {
            nextToken
            __typename
          }
          __typename
        }
        phot {
          id
          alternate
          storage {
            bucket
            region
            key
            __typename
          }
          url
          owner
          version
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlbumMutationVariables,
  APITypes.UpdateAlbumMutation
>;
export const deleteAlbum = /* GraphQL */ `mutation DeleteAlbum(
  $input: DeleteAlbumInput!
  $condition: ModelAlbumConditionInput
) {
  deleteAlbum(input: $input, condition: $condition) {
    id
    name
    owner
    version
    createdAt
    updatedAt
    phots {
      items {
        id
        albumID
        photID
        albumOrder
        owner
        version
        createdAt
        updatedAt
        album {
          id
          name
          owner
          version
          createdAt
          updatedAt
          phots {
            nextToken
            __typename
          }
          __typename
        }
        phot {
          id
          alternate
          storage {
            bucket
            region
            key
            __typename
          }
          url
          owner
          version
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlbumMutationVariables,
  APITypes.DeleteAlbumMutation
>;
export const createBoothBoatType = /* GraphQL */ `mutation CreateBoothBoatType(
  $input: CreateBoothBoatTypeInput!
  $condition: ModelBoothBoatTypeConditionInput
) {
  createBoothBoatType(input: $input, condition: $condition) {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBoothBoatTypeMutationVariables,
  APITypes.CreateBoothBoatTypeMutation
>;
export const updateBoothBoatType = /* GraphQL */ `mutation UpdateBoothBoatType(
  $input: UpdateBoothBoatTypeInput!
  $condition: ModelBoothBoatTypeConditionInput
) {
  updateBoothBoatType(input: $input, condition: $condition) {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBoothBoatTypeMutationVariables,
  APITypes.UpdateBoothBoatTypeMutation
>;
export const deleteBoothBoatType = /* GraphQL */ `mutation DeleteBoothBoatType(
  $input: DeleteBoothBoatTypeInput!
  $condition: ModelBoothBoatTypeConditionInput
) {
  deleteBoothBoatType(input: $input, condition: $condition) {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBoothBoatTypeMutationVariables,
  APITypes.DeleteBoothBoatTypeMutation
>;
export const createBoothBoatBrand = /* GraphQL */ `mutation CreateBoothBoatBrand(
  $input: CreateBoothBoatBrandInput!
  $condition: ModelBoothBoatBrandConditionInput
) {
  createBoothBoatBrand(input: $input, condition: $condition) {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBoothBoatBrandMutationVariables,
  APITypes.CreateBoothBoatBrandMutation
>;
export const updateBoothBoatBrand = /* GraphQL */ `mutation UpdateBoothBoatBrand(
  $input: UpdateBoothBoatBrandInput!
  $condition: ModelBoothBoatBrandConditionInput
) {
  updateBoothBoatBrand(input: $input, condition: $condition) {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBoothBoatBrandMutationVariables,
  APITypes.UpdateBoothBoatBrandMutation
>;
export const deleteBoothBoatBrand = /* GraphQL */ `mutation DeleteBoothBoatBrand(
  $input: DeleteBoothBoatBrandInput!
  $condition: ModelBoothBoatBrandConditionInput
) {
  deleteBoothBoatBrand(input: $input, condition: $condition) {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBoothBoatBrandMutationVariables,
  APITypes.DeleteBoothBoatBrandMutation
>;
export const createAlbumPhot = /* GraphQL */ `mutation CreateAlbumPhot(
  $input: CreateAlbumPhotInput!
  $condition: ModelAlbumPhotConditionInput
) {
  createAlbumPhot(input: $input, condition: $condition) {
    id
    albumID
    photID
    albumOrder
    owner
    version
    createdAt
    updatedAt
    album {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    phot {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlbumPhotMutationVariables,
  APITypes.CreateAlbumPhotMutation
>;
export const updateAlbumPhot = /* GraphQL */ `mutation UpdateAlbumPhot(
  $input: UpdateAlbumPhotInput!
  $condition: ModelAlbumPhotConditionInput
) {
  updateAlbumPhot(input: $input, condition: $condition) {
    id
    albumID
    photID
    albumOrder
    owner
    version
    createdAt
    updatedAt
    album {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    phot {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlbumPhotMutationVariables,
  APITypes.UpdateAlbumPhotMutation
>;
export const deleteAlbumPhot = /* GraphQL */ `mutation DeleteAlbumPhot(
  $input: DeleteAlbumPhotInput!
  $condition: ModelAlbumPhotConditionInput
) {
  deleteAlbumPhot(input: $input, condition: $condition) {
    id
    albumID
    photID
    albumOrder
    owner
    version
    createdAt
    updatedAt
    album {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    phot {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlbumPhotMutationVariables,
  APITypes.DeleteAlbumPhotMutation
>;
export const createImage = /* GraphQL */ `mutation CreateImage(
  $input: CreateImageInput!
  $condition: ModelImageConditionInput
) {
  createImage(input: $input, condition: $condition) {
    id
    alternate
    storage {
      bucket
      region
      key
      __typename
    }
    url
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateImageMutationVariables,
  APITypes.CreateImageMutation
>;
export const updateImage = /* GraphQL */ `mutation UpdateImage(
  $input: UpdateImageInput!
  $condition: ModelImageConditionInput
) {
  updateImage(input: $input, condition: $condition) {
    id
    alternate
    storage {
      bucket
      region
      key
      __typename
    }
    url
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateImageMutationVariables,
  APITypes.UpdateImageMutation
>;
export const deleteImage = /* GraphQL */ `mutation DeleteImage(
  $input: DeleteImageInput!
  $condition: ModelImageConditionInput
) {
  deleteImage(input: $input, condition: $condition) {
    id
    alternate
    storage {
      bucket
      region
      key
      __typename
    }
    url
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteImageMutationVariables,
  APITypes.DeleteImageMutation
>;
export const createShowAudience = /* GraphQL */ `mutation CreateShowAudience(
  $input: CreateShowAudienceInput!
  $condition: ModelShowAudienceConditionInput
) {
  createShowAudience(input: $input, condition: $condition) {
    id
    showID
    userID
    owner
    version
    createdAt
    updatedAt
    show {
      id
      name
      version
      owner
      createdAt
      updatedAt
      __typename
    }
    users {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShowAudienceMutationVariables,
  APITypes.CreateShowAudienceMutation
>;
export const updateShowAudience = /* GraphQL */ `mutation UpdateShowAudience(
  $input: UpdateShowAudienceInput!
  $condition: ModelShowAudienceConditionInput
) {
  updateShowAudience(input: $input, condition: $condition) {
    id
    showID
    userID
    owner
    version
    createdAt
    updatedAt
    show {
      id
      name
      version
      owner
      createdAt
      updatedAt
      __typename
    }
    users {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShowAudienceMutationVariables,
  APITypes.UpdateShowAudienceMutation
>;
export const deleteShowAudience = /* GraphQL */ `mutation DeleteShowAudience(
  $input: DeleteShowAudienceInput!
  $condition: ModelShowAudienceConditionInput
) {
  deleteShowAudience(input: $input, condition: $condition) {
    id
    showID
    userID
    owner
    version
    createdAt
    updatedAt
    show {
      id
      name
      version
      owner
      createdAt
      updatedAt
      __typename
    }
    users {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteShowAudienceMutationVariables,
  APITypes.DeleteShowAudienceMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    identity_id
    email
    group
    version
    createdAt
    updatedAt
    tickets {
      items {
        id
        status
        group
        version
        createdAt
        updatedAt
        activatedUser {
          id
          identity_id
          email
          group
          version
          createdAt
          updatedAt
          tickets {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    identity_id
    email
    group
    version
    createdAt
    updatedAt
    tickets {
      items {
        id
        status
        group
        version
        createdAt
        updatedAt
        activatedUser {
          id
          identity_id
          email
          group
          version
          createdAt
          updatedAt
          tickets {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    identity_id
    email
    group
    version
    createdAt
    updatedAt
    tickets {
      items {
        id
        status
        group
        version
        createdAt
        updatedAt
        activatedUser {
          id
          identity_id
          email
          group
          version
          createdAt
          updatedAt
          tickets {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createTicket = /* GraphQL */ `mutation CreateTicket(
  $input: CreateTicketInput!
  $condition: ModelTicketConditionInput
) {
  createTicket(input: $input, condition: $condition) {
    id
    status
    group
    version
    createdAt
    updatedAt
    activatedUser {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTicketMutationVariables,
  APITypes.CreateTicketMutation
>;
export const updateTicket = /* GraphQL */ `mutation UpdateTicket(
  $input: UpdateTicketInput!
  $condition: ModelTicketConditionInput
) {
  updateTicket(input: $input, condition: $condition) {
    id
    status
    group
    version
    createdAt
    updatedAt
    activatedUser {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTicketMutationVariables,
  APITypes.UpdateTicketMutation
>;
export const deleteTicket = /* GraphQL */ `mutation DeleteTicket(
  $input: DeleteTicketInput!
  $condition: ModelTicketConditionInput
) {
  deleteTicket(input: $input, condition: $condition) {
    id
    status
    group
    version
    createdAt
    updatedAt
    activatedUser {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTicketMutationVariables,
  APITypes.DeleteTicketMutation
>;
